import _slicedToArray from "/agent/_work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as e, useEffect as n } from "react";
var i = function i() {
  var _e = e("undefined" != typeof window ? window.innerWidth : 0),
    _e2 = _slicedToArray(_e, 2),
    i = _e2[0],
    t = _e2[1];
  return n(function () {
    var e = function e() {
      t(window.innerWidth);
    };
    return window.addEventListener("resize", e), function () {
      return window.removeEventListener("resize", e);
    };
  }, []), {
    isMobile: i < 768,
    isTablet: i >= 768 && i < 1024,
    isDesktop: i >= 1024
  };
};
export { i as useScreenRecognition };